export default {"src":"/_next/static/media/LKQ.82477a4c.svg","height":18,"width":18};